import type { FunnelTemplate } from "@/lib/funnel-planner/engine";

export const aiSearchGeoTemplate: FunnelTemplate = {
  id: "ai-search-geo",
  serviceLine: "GEO",
  recommendedBands: ["starter", "growth"],
  pdfAccentColor: "#7c3aed",
  defaultTrafficChannels: [
    { id: "google_organic", label: "Google Organic",    monthlyVisitors: 600, acquisitionType: "organic" },
    { id: "other_search",   label: "Other Search / AI", monthlyVisitors: 300, acquisitionType: "organic" },
    { id: "linkedin",       label: "LinkedIn",           monthlyVisitors: 100, acquisitionType: "organic" },
  ],
  defaultStages: [
    { id: "ai-mention", conversionRate: 100, isEditable: false, stageType: "blog-post" },
    { id: "click",      conversionRate: 2.5, isEditable: true,  stageType: "landing-page" },
    { id: "engage",     conversionRate: 20,  isEditable: true,  stageType: "email-sequence" },
    { id: "lead",       conversionRate: 5,   isEditable: true,  stageType: "opt-in-page" },
    { id: "close",      conversionRate: 25,  isEditable: true,  stageType: "retainer-close" },
  ],
};
